import React, { type FC, type ReactNode, useEffect } from "react";
import { useDroppable } from "@dnd-kit/core";

interface IProps {
    children: ReactNode;
    id: string;
    onDropStyle: (isDrop: boolean) => void;
    typeKeyPath?: string[];
}

export const SidebarMenuItemDropWrapper: FC<IProps> = ({ children, id, onDropStyle, typeKeyPath }) => {
    const { isOver, setNodeRef, active } = useDroppable({
        id,
        data: {
            destinationFolderKeyPath: typeKeyPath,
        },
    });

    // Determine if we can drop based on active drag
    const canDrop = Boolean(active?.data?.current?.documentIds?.length);

    useEffect(() => {
        onDropStyle(canDrop && isOver);
    }, [canDrop, isOver, onDropStyle]);

    return (
        <div style={{ width: "100%" }} ref={setNodeRef}>
            {children}
        </div>
    );
};
